const doObserve = (element) => {
    const targets = document.querySelectorAll('.js-typeWriter');
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };

    const observer = new IntersectionObserver((items) => {
        items.forEach((item) => {
            if (item.isIntersecting) {
                const typeWriter = selector => {
                    const el = document.querySelector(selector);
                    const text = el.innerHTML;

                    (function _type(i = 0) {
                        if (i === text.length) {
                            // アニメーションが完了したら、他の要素に関するアニメーションをトリガー
                            animateOtherElements();
                            return;
                        }
                        el.innerHTML = text.substring(0, i + 1) + '<span aria-hidden="true"></span>';
                        setTimeout(() => _type(i + 1), 100);
                    })();
                };

                const animateOtherElements = () => {
                    // js-typeWriterのアニメーションが完了した後、他の要素にアニメーションを追加
                    // 例えば、他の要素にfadeInの効果を追加することができます
                    const elementsToAnimate = document.querySelectorAll('.p-kv__bg, .p-kv__lead, .p-kv__balloon');
                    elementsToAnimate.forEach(element => {
                        element.style.opacity = 0;
                        element.style.transition = 'opacity 1s ease-in-out';
                        setTimeout(() => {
                            element.style.opacity = 1;
                        }, 100);
                    });
                };

                typeWriter(".js-typeWriter");

                // 1回観測した後はIntersectionObserverを切断
                observer.disconnect();
            } else {
                item.target.classList.remove('typing');
            }
        });
    }, options);

    Array.from(targets).forEach((target) => {
        observer.observe(target);
    });
};

// ターゲットの要素を指定して関数を呼び出す
doObserve('.observe_target');
